
import React from 'react';
import '../styles/Page.css';

function About() {
  return (
    <div className="page-container">
      <div className="page-content">
        <h1 className="glitch" data-text="About Me">About Me</h1>
        <div className="page-card">
          <p>Nacho Pereira is a multidisciplinary visual artist based in [Your City]. His work explores the intersection of technology, art, and consciousness, utilizing photography, video, 3D rendering, and artificial intelligence to create immersive and thought-provoking experiences.</p>
          <p>With a background in both traditional and digital art forms, Nacho's work is characterized by its bold, futuristic aesthetic and its deep engagement with the themes of cyberpunk, identity, and the nature of reality in the digital age.</p>
        </div>
      </div>
    </div>
  );
}

export default About;
